export default {
  CONFIRM_PASSWORD: 'Passwort bestätigen',
  FORGOT_PASSWORD_CAPTION:
    'Kein Problem. Geben Sie Ihren Benutzernamen ein und wir teilen einen Link zum Zurücksetzen der registrierten E-Mail-Adresse.',
  PASSWORD_EMAIL_SUCCESS: 'Ein neues Passwort wurde an Ihre registrierte E-Mail-Adresse gesendet.',
  SENT_EMAIL_TITLE: 'Neues Passwort gesendet',
  INVALID_RESET_PASS_LINK: 'Anscheinend ist Ihr Link zum Zurücksetzen des Passworts ungültig. Bitte versuchen Sie es erneut.',
  RESET_PASS_SUCCESS: 'Ihr Passwort wurde erfolgreich zurückgesetzt, bitte melden Sie sich an.',
  RESET_PASS_LINK_EXPIRED: 'Anscheinend ist Ihr Link zum Zurücksetzen des Passworts abgelaufen. Bitte versuchen Sie es erneut.',
  PASSWORDS_NOT_SAME: 'Ihr neues Passwort und die Passwortbestätigung müssen übereinstimmen!',
  RESET_PASSWORD: 'Passwort zurücksetzen',
  RESET_PASSWORD_CAPTION: 'Bitte geben Sie Ihr neues Passwort ein und klicken Sie auf die Schaltfläche Absenden.'
}
